import { PageHeader } from '../../../ui'

export interface viewTitleProps {
    text: String
    button?: React.ReactNode
}

/**
 * Legacy page title. New code should use `PageHeader` from `ui` directly,
 * which adds intro / meta / back-link slots.
 */
export const ViewTitle = ({ text, button }: viewTitleProps) => <PageHeader title={String(text)} actions={button} />
